export default {
  getPaymentList(state) {
    return state.paymentList;
  },

  getPaymentDetail(state) {
    return state.paymentInfo;
  }
};
